/**
 * @file コンポーネント：フル動画ページフル動画プレイヤーボタンリスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { fontFamily } from "~/src/styles/constants";
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledButtonlist = styled.ul`
    display: inline-flex;
`;

export const StyledButtonlistButton = styled.button`
    position: relative;
    width: 30px;
    height: 30px;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #bfbfbf !important;
    font-size: 14px;

    &:disabled {
        color: #6c757d;
        cursor: auto;
    }

    &:hover {
        color: #fff !important;
    }

    &.is-off {
        &::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: rotate(315deg);
            width: 80%;
            height: 2px;
            margin: auto;
            background-color: #ffffff;
            content: "";
        }

        > i {
            mask-image: url(/assets/images/mask-is-off-icon.png);
            mask-size: contain;
        }
    }

    i {
        font-size: 17px;
    }
`;

export const StyledButtonlistButtonText = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    line-height: 32px;
    font-weight: bold;
    font-size: 10px;
    text-shadow: 0 0 3px #000, 0 0 3px #000, 0 0 3px #000, 0 0 3px #000,
        0 0 3px #000, 0 0 3px #000, 0 0 3px #000, 0 0 3px #000;
`;

export const StyledButtonlistItem = styled.li`
    position: relative;
`;

export const StyledButtonlistJump = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledButtonlistJumpInput = styled.input`
    width: 48px;
    height: 20px;
    margin-right: 4px;
    padding: 0 4px;
    border: 1px solid #6c757d;
    background-color: transparent;
    color: #ffffff;
    font-size: 10px;
`;

export const StyledButtonlistJumpPulldown = styled.div`
    position: relative;
    height: 20px;
    border: 1px solid #6c757d;

    &::after {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        width: 20px;
        height: 20px;
        margin: auto 0;
        color: #6c757d;
        font-weight: bold;
        font-size: 10px;
        font-family: ${fontFamily.icon};
        line-height: 20px;
        text-align: center;
        content: "\f0d7";
    }
`;

export const StyledButtonlistJumpPulldownSelect = styled.select`
    position: relative;
    z-index: 2;
    height: 100%;
    padding: 0 20px 0 4px;
    border: none;
    background-color: transparent;
    color: #ffffff;
    font-size: 10px;
`;

export const StyledButtonlistJumpPulldownSelectOption = styled.option`
    background-color: #ffffff !important;
    color: #000000;
`;

export const StyledButtonlistMenu = styled.div`
    display: none;
    position: absolute;
    right: 0;
    bottom: 100%;
    cursor: pointer;
    z-index: ${zIndex.fullvideoSubmenu};

    &.is-show {
        display: block;
    }
`;

export const StyledButtonlistMenuLabel = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const StyledButtonlistMenuLabelCheckbox = styled.input`
    margin: 0 4px 0 0;
`;

export const StyledButtonlistMenuLabelIcon = styled.label`
    margin-right: 4px;
`;

export const StyledButtonlistMenuLabelText = styled.span`
    white-space: nowrap;
`;

export const StyledButtonlistMenuList = styled.dl`
    padding: 12px;
    background-color: rgba(60, 69, 79, 0.8);
`;

export const StyledButtonlistMenuListDetail = styled.dd`
    padding: 5px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 11px;
    line-height: 14px;
    font-family: ${fontFamily.mediaPlayer};
`;

export const StyledButtonlistMenuListTerm = styled.dt`
    padding: 5px;
    color: #ffffff;
    font-weight: bold;
    font-size: 11px;
    font-family: ${fontFamily.mediaPlayer};
`;
